import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import config from "@/lib/config";
import { maskTargetKeys, metaSchemas, userRating } from "@/lib/constants";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";
function recurciveMask() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const copiedData = JSON.parse(JSON.stringify(data));
  function mask(key, value) {
    if (Array.isArray(value)) {
      return value.map(v => mask(key, v));
    } else if (typeof value === "object") {
      return recurciveMask(value);
    } else if (typeof value === "string") {
      if (maskTargetKeys.includes(key)) {
        return value.replace(/./g, "*");
      } else {
        return value;
      }
    }
    return value;
  }
  for (const key in copiedData) {
    const value = copiedData[key];
    copiedData[key] = mask(key, value);
  }
  return copiedData;
}
class IdcAPI extends RESTDataSource {
  constructor(options) {
    super(options);
    _defineProperty(this, "baseURL", config.idc.domain);
    this.context = options;
  }
  get config() {
    var _this$context$req, _this$context$req2, _this$context$req3;
    return {
      service: config.service,
      deviceCode: this.context.req.deviceCode,
      appId: config.appId["vod"],
      storeId: config.storeId["vod"],
      valuePlanId: config.valuePlanId["vod"],
      userId: (_this$context$req = this.context.req) === null || _this$context$req === void 0 || (_this$context$req = _this$context$req.userToken) === null || _this$context$req === void 0 ? void 0 : _this$context$req.id,
      profileId: (_this$context$req2 = this.context.req) === null || _this$context$req2 === void 0 || (_this$context$req2 = _this$context$req2.userToken) === null || _this$context$req2 === void 0 ? void 0 : _this$context$req2.currentProfile,
      rating: (_this$context$req3 = this.context.req) === null || _this$context$req3 === void 0 || (_this$context$req3 = _this$context$req3.userToken) === null || _this$context$req3 === void 0 ? void 0 : _this$context$req3.rating
    };
  }
  isMaybeLoggedIn() {
    var _this$context$req4;
    return !!((_this$context$req4 = this.context.req) !== null && _this$context$req4 !== void 0 && (_this$context$req4 = _this$context$req4.idcToken) !== null && _this$context$req4 !== void 0 && _this$context$req4.accessToken);
  }
  willSendRequest(_path, request) {
    var _this$context$req5, _this$context$req7, _this$context$req8;
    request.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // IPアドレスをforward
    const remoteIp = getRemoteIpAddress(this.context.req);
    request.headers["X-Forwarded-For"] = remoteIp;
    // UAをプロキシする
    request.headers["User-Agent"] = `${(_this$context$req5 = this.context.req) === null || _this$context$req5 === void 0 || (_this$context$req5 = _this$context$req5.deviceInfo) === null || _this$context$req5 === void 0 ? void 0 : _this$context$req5.ua} spooxweb`;
    if (_path === "/idcs/sso/TokenEndpoint" || _path === "/idcs/sso/RefreshToken") {
      const accessToken = Buffer.from(`${config.idc.clientId}:${config.idc.clientSecret}`).toString("base64");
      request.headers["Authorization"] = `Basic ${accessToken}`;
    } else {
      var _this$context$req6;
      const accessToken = (_this$context$req6 = this.context.req) === null || _this$context$req6 === void 0 || (_this$context$req6 = _this$context$req6.idcToken) === null || _this$context$req6 === void 0 ? void 0 : _this$context$req6.accessToken;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const requestParams = request.params || null;
    const operationName = ((_this$context$req7 = this.context.req) === null || _this$context$req7 === void 0 || (_this$context$req7 = _this$context$req7.query) === null || _this$context$req7 === void 0 ? void 0 : _this$context$req7.operationName) || "unknown";
    const url = ((_this$context$req8 = this.context.req) === null || _this$context$req8 === void 0 ? void 0 : _this$context$req8.url) || "unknown";
    try {
      // 個人情報をマスクする
      const maskedBody = recurciveMask(request.body);
      const maskedBodyStr = JSON.stringify(maskedBody || null);
      console.log(`[IDC][REQUEST INFO] Method: ${request.method}, Path: ${_path}, Params: ${requestParams},  Body: ${maskedBodyStr}, OperationName: ${operationName}, URL: ${url} Authorization: ${request.headers["Authorization"]} ContentType: ${request.headers["Content-Type"]}`);
    } catch (e) {
      // 万が一エラーになってもサービスを止めないようにエラーを潰す
      console.log(e);
    }
  }
  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Idc-Request-Id"];
    const responseBody = await super.didReceiveResponse(response, request);
    console.log(`[${requestId}][IDC][RESPONSE INFO] Status: ${response.status}`);
    return responseBody;
  }
}
export default IdcAPI;